import { useState } from "react";
import { instance } from "../../../../utils/utils";

const rol = {
  10: "Super Usuario",
  20: "Operativo",
  30: "Profesional de la salud",
};
const ModalAddUserRol = ({ onClose, onSuccess }) => {
  const [loader, setLoader] = useState(false);
  const [rolSelected, setRolSelected] = useState("");
  const [error, setError] = useState(null);
  const addUserRol = async (e) => {
    e.preventDefault();
    setLoader(true);
    try {
      let formData = new FormData(e.target);
      formData.append("email", formData.get("email"));
      formData.append("password", formData.get("password"));
      formData.append("first_name", formData.get("first_name"));
      formData.append("last_name", formData.get("last_name"));
      formData.append("role", formData.get("role"));

      const response = await instance.post("users/roles/", formData);

      // toast.success("Usuario creado exitosamente");
      onSuccess && onSuccess(response.data);
      onClose();
    } catch (err) {
      console.error(err);
      let errorMessage = "Ocurrió un error al crear el usuario";

      if (err.response) {
        // The request was made and the server responded with a status code
        // that falls out of the range of 2xx
        if (err.response.status === 400) {
          // Handle validation errors
          const errors = err.response.data;
          errorMessage = Object.values(errors).flat().join(" ");
        } else if (err.response.status === 401) {
          errorMessage = "No tienes permiso para realizar esta acción";
        } else if (err.response.status >= 500) {
          errorMessage = "Error en el servidor. Por favor, intente más tarde";
        }
      } else if (err.request) {
        // The request was made but no response was received
        errorMessage =
          "No se pudo conectar al servidor. Verifica tu conexión a internet";
      }

      setError(errorMessage);
      setTimeout(() => {
        setError(null);
      }, 3000);
    } finally {
      setLoader(false);
    }
  };
  return (
    <div>
      <div className="mb-4">
        <span style={{ textAlign: "center" }}>
          {loader ? (
            <span style={{ textAlign: "center" }}>Cargando...</span>
          ) : (
            <span
              style={{
                textAlign: "center",
                fontSize: "calc( 0.85rem + 0.5vw )",
              }}
            >
              Nuevo <strong>Usuario con rol</strong>
            </span>
          )}
        </span>
        {error && (
          <div
            className="alert alert-danger mt-2 py-1"
            style={{ fontSize: "0.8rem" }}
          >
            {error}
          </div>
        )}
      </div>
      <form onSubmit={addUserRol} className="d-flex flex-column gap-2">
        <div className="d-flex px-4">
          <input
            required
            defaultValue={""}
            placeholder="Ingresa el Nombre"
            name="first_name"
            type="search"
            className="searchAtletas  py-2 mx-auto"
            style={{
              border: "1px solid var(--elevvaTextSubtitle)",
              borderRadius: "20px",
              fontSize: "calc(.4rem + .4vw)",
              width: "100%",
            }}
          ></input>
        </div>
        <div className="d-flex px-4">
          <input
            required
            defaultValue={""}
            placeholder="Ingresa el Apellido"
            name="last_name"
            type="search"
            className="searchAtletas  py-2 mx-auto"
            style={{
              border: "1px solid var(--elevvaTextSubtitle)",
              borderRadius: "20px",
              fontSize: "calc(.4rem + .4vw)",
              width: "100%",
            }}
          ></input>
        </div>

        <div className="d-flex px-4">
          <input
            required
            defaultValue={""}
            placeholder="Ingresa el Correo Electrónico"
            name="email"
            type="email"
            className="searchAtletas  py-2 mx-auto"
            style={{
              border: "1px solid var(--elevvaTextSubtitle)",
              borderRadius: "20px",
              fontSize: "calc(.4rem + .4vw)",
              width: "100%",
            }}
          ></input>
        </div>
        <div className="d-flex px-4">
          <input
            required
            defaultValue={""}
            placeholder="Ingresa la Contraseña"
            name="password"
            type="password"
            className="searchAtletas  py-2 mx-auto"
            style={{
              border: "1px solid var(--elevvaTextSubtitle)",
              borderRadius: "20px",
              fontSize: "calc(.4rem + .4vw)",
              width: "100%",
            }}
          ></input>
        </div>
        <div className="d-flex px-4">
          <select
            required
            name="role"
            id="role"
            onChange={(e) => setRolSelected(e.target.value)}
            className="searchAtletas  py-2 mx-auto"
            style={{
              border: "1px solid var(--elevvaTextSubtitle)",
              borderRadius: "20px",
              fontSize: "calc(.4rem + .4vw)",
              width: "100%",
            }}
          >
            <option value="">Tipo de Rol</option>
            {Object.entries(rol).map(([key, value]) => (
              <option key={key} value={key}>
                {value}
              </option>
            ))}
          </select>
        </div>
        {rolSelected && Number(rolSelected) > 0 && (
          <div
            className="px-4 mt-2 w-100"
            style={{ textAlign: "left", maxWidth: "35rem" }}
          >
            <span>
              <strong>{rol[Number(rolSelected)]}:</strong>
              <br></br>
              <span style={{ fontSize: "calc(.4rem + .4vw)" }}>
                {Number(rolSelected) === 10
                  ? ` * Dueño de la cuenta corporativa. Tiene acceso total a todos los paneles, puede agregar medios de pago y gestionar la creación de otros usuarios.`
                  : Number(rolSelected) === 20
                  ? ` * Encargado de la gestión diaria del gimnasio. Solo puede acceder a los paneles de gimnasios y membresías, sin acceso a datos sensibles.`
                  : `* Debe ser un profesional del deporte o la salud. Tiene acceso a paneles de salud, seguimiento de clientes y gráficas con datos sensibles.`}
              </span>
            </span>
          </div>
        )}
        <div className="d-flex justify-content-center mt-3">
          <button
            type="submit"
            style={{
              fontSize: "calc(.4rem + .32vw)",
            }}
            className="d-flex add_location px-4 py-2"
          >
            Confirmar
          </button>
        </div>
      </form>
    </div>
  );
};
export default ModalAddUserRol;
